import { useTenantPermission } from "./useTenantPermission";

/** Writing data into the organization: the permission a tenant admin holds, a member doesn't. */
export const DATA_WRITE_PERMISSION = "data:write";

/** Whether the signed-in user may add a file as a data source (the backend still enforces it). */
export const useFileUploadAccess = (): { canUpload: boolean; loading: boolean } => {
  const { allowed, loading } = useTenantPermission(DATA_WRITE_PERMISSION);
  return { canUpload: allowed, loading };
};
